export * from './SubmitButton';



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/SubmitButton/index.jsx